// extracted by mini-css-extract-plugin
export default {"icon":"verified-reviews-message__icon___2xCFr"};